import { ShipOrderLineItem } from '../ShipOrderLineItem';

export class ValidShipOrderLineItem extends ShipOrderLineItem {
  id: number;
  quantity: number;

  constructor(opts?: Partial<ValidShipOrderLineItem>) {
    super(opts);

    if (opts?.id) {
      this.id = opts.id;
    } else {
      throw new Error('Invalid ShipOrderLineItem - id is required');
    }

    if (opts?.quantity) {
      this.quantity = opts.quantity;
    } else {
      throw new Error('Invalid ShipOrderLineItem - quantity is required');
    }
  }

  static isValidShipOrderLineItem(
    shipOrderLineItem: ShipOrderLineItem,
  ): shipOrderLineItem is ValidShipOrderLineItem {
    return !!shipOrderLineItem.id && !!shipOrderLineItem.quantity;
  }
}
